export default "__VITE_ASSET__BeQ19lgr__"